import { render } from "./IncidentChartCategory.vue?vue&type=template&id=2ab4e1e0"
import script from "./IncidentChartCategory.vue?vue&type=script&lang=js"
export * from "./IncidentChartCategory.vue?vue&type=script&lang=js"

import "./IncidentChartCategory.vue?vue&type=style&index=0&id=2ab4e1e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__